export const convertM2ToSquareFeet = m2 => parseInt(Math.round(m2 * 10.764))

export const convertKmToMi = km => parseInt(Math.round(km / 1.609))
